module.exports = __webpack_public_path__ + "img/x2.cc34d792.jpg";